<template>
  <div
    class="menu-page-desktop"
    :class="{ 'menu-page-mobile': $route.meta.mobile }"
  >
    <h1>{{ $t("partners.title") }}</h1>
    <p>
      {{ $t("partners.p1") }}
    </p>

    <ul>
      <li>{{ $t("partners.ul-partners-li-1") }}</li>
      <li>{{ $t("partners.ul-partners-li-2") }}</li>
      <li>{{ $t("partners.ul-partners-li-3") }}</li>
      <li>{{ $t("partners.ul-partners-li-4") }}</li>
      <li>{{ $t("partners.ul-partners-li-5") }}</li>
      <li>{{ $t("partners.ul-partners-li-6") }}</li>
      <li>{{ $t("partners.ul-partners-li-7") }}</li>
      <li>{{ $t("partners.ul-partners-li-8") }}</li>
      <li>{{ $t("partners.ul-partners-li-9") }}</li>
      <li>{{ $t("partners.ul-partners-li-10") }}</li>
      <li>{{ $t("partners.ul-partners-li-11") }}</li>
      <li>{{ $t("partners.ul-partners-li-12") }}</li>
    </ul>

    <br />
    <hr />
    <br />

    <div class="listing">
      <h2>{{ $t("partners.s1") }}</h2>
      <div>{{ $t("partners.s2") }}</div>
      <div>{{ $t("partners.s3") }}</div>
      <div>{{ $t("partners.s4") }}</div>
      <div>{{ $t("partners.s5") }}</div>
      <div>{{ $t("partners.s6") }}</div>
      <div>{{ $t("partners.s7") }}</div>
      <div>{{ $t("partners.s8") }}</div>
    </div>

    <div class="logos" :class="getAppName()">
      <div class="logo-container">
        <img src="../svg/Huygenstijdmachine_Provincie-Zuid-Holland.svg" />
      </div>

      <div class="logo-container">
        <img src="../svg/Huygenstijdmachine-05.svg" />
      </div>

      <div class="logo-container">
        <img
          src="../svg/Huygenstijdmachine_Gemeente-Leidschendam-Voorburg.svg"
        />
      </div>

      <div class="logo-container">
        <img src="../svg/Huygenstijdmachine_Hendrik-Mullerfonds.svg" />
      </div>

      <div class="logo-container">
        <img src="../svg/Huygenstijdmachine_Cultuurfonds.svg" />
      </div>

      <div class="logo-container">
        <img src="../svg/Huygenstijdmachine_Stichting-Thurkow-fonds.svg" />
      </div>

      <div class="logo-container">
        <img src="../svg/Huygenstijdmachine_Mr-August-Fentener.svg" />
      </div>
    </div>

    <hr v-if="getAppName() !== 'huygens'" />
    <page-footer v-if="getAppName() !== 'huygens'" />
  </div>
</template>

<script>
import PageFooter from "@/components/menus/pages/PageFooter.vue";
import { appIdentifier } from "@/utils/appIdentifier.js";

export default {
  components: {
    PageFooter
  },

  methods: {
    getAppName() {
      return appIdentifier();
    }
  },
  head: {
    meta: [
      {
        name: "viewport",
        content: "width=device-width, shrink-to-fit=YES",
        initialScale: "1.0",
        maximumScale: "1.0",
        minimumScale: "1.0",
        userScalable: "no"
      }
    ]
  }
};
</script>

<style scoped src="../css/main.css"></style>
